/*
 Funções utilizando JS puro para mostrar modal de erro para checkout em andamento.
*/

import { checkoutErrorsGET } from "../shared/mocks/modal-checkout-GET";
import { openModal } from "../vanilla/modal";

export const getModalCheckoutError = errorCode => {
	let errorContent = false;
	switch (errorCode) {
		case 404:
			errorContent = checkoutErrorsGET["checkoutNotExists"];
			break;
		case 401:
			errorContent = checkoutErrorsGET["notAutorized"];
			break;
		case 409:
			errorContent = checkoutErrorsGET["checkoutExpired"];
			break;
		case 410:
			errorContent = checkoutErrorsGET["checkoutExpired"];
			break;
		default:
			errorContent = checkoutErrorsGET["checkoutDefaultError"];
	}

	return errorContent;
};

export const showModalCheckoutError = errorContent => {
	if (errorContent) {
		openModal(errorContent);
	}
};
